import { memo } from 'react'
import ReactInk, { InkProperties } from 'react-ink'

// 水波纹效果
function Ink(props: InkProperties) {
  return <ReactInk radius={100} opacity={0.02} {...props} />
}

export default memo(Ink)
